import { makeStyles } from '@material-ui/styles';

export default makeStyles(
    {
        root: {
            display: 'flex',
            justifyContent: 'flex-end',
            flexDirection: 'column-reverse',
            padding: '20px',
            overflow: 'none',
        },
        widget: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '20vh',
            flexDirection: 'column',
        },
    },
);